import { Grid, Typography } from "@mui/material";
import { memo, useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import strings from '../../../Globalization/index';
import CustomTabs from '../../../components/common/Tabs';
import { useAdvantageCycleInfo } from "../Context";
import Charts from "./Charts";

const ProcessMonitor = () => {
	const { data } = useAdvantageCycleInfo();
	const [searchParams, setSearchParams] = useSearchParams();
	const { ISAChartData = {} } = data || {};
	const [tabs, tabNames] = useMemo(() => {
		const tabs = [];
		if (ISAChartData) {
			const properties = Object.keys(ISAChartData);
			let i = 1;
			for (const property of properties) {
				if (ISAChartData[property]) {
					const name = `pm-${i++}`;
					const label = ISAChartData[property].PhaseName;
					tabs.push({
						name,
						label,
						Component: Charts,
						property: property,
						isISARAER: true,
					});
				}
			}
		}
		const tabNames = tabs.map((tab) => tab.name);
		return [tabs, tabNames];
	}, [data]);

	const tab = useMemo(() => {
		const tabName = searchParams.has('tab') ? searchParams.get('tab') : 0;
		const tabIndex = tabNames.indexOf(tabName);
		return tabIndex !== -1 ? tabIndex : 0;
	}, [searchParams, tabNames]);


	const handleOnTabChange = useCallback(
		(event, i) => {
			if (tab !== i && tabNames[i]) {
				const searchParamsObj = {};
				for (const [key, value] of searchParams.entries()) {
					searchParamsObj[key] = value;
				}
				searchParamsObj.tab = tabNames[i];
				setSearchParams(searchParamsObj);
			}
		},
		[searchParams, tabNames, setSearchParams, tab]
	);
	return (
		!ISAChartData || Object.keys(ISAChartData).length === 0 ? (
			<Grid size={12} className="print-clear" paddingTop={3}>
				<Typography variant="body2" className="text-center">
					{strings.NoChartDataAvailableForCycle}
				</Typography>
			</Grid>
		) : (
			<Grid container>
				<Grid size={12}>
					<CustomTabs
						tabs={tabs}
						tab={tab}
						onChange={handleOnTabChange}
					/>
				</Grid>
			</Grid>

		));
}

export default memo(ProcessMonitor);